import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { tabs } from 'src/app/dummy/tabs';
import { DataService } from 'src/app/services/data.service';
import { List } from 'src/app/stores/administrator/list.store';

@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.scss']
})
export class SettingComponent implements OnInit {
  tabs = tabs.HOLIDAY

  constructor(
    private router: Router,
    public store: List,
    public ds: DataService,
    public dialog: MatDialog) { }


  ngOnInit() {
    this.store.fetchData(this.ds.settingsRef(ref => ref.orderBy("fromDateKey")))
  }

  ngOnDestroy() {
    this.store.dispost();
  }
}
